import { useEffect } from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import matchEntityLink from '../editor/utils/matchEntityLink';
import { miscToasts } from '../toasts/toasts';
import { UIActions } from '../ui/uiSlice';
import { isElectron } from './desktopClient';

const usePreferDesktopNotice = () => {
  const dispatch = useAppDispatch();

  const shouldPreferDesktop = useAppSelector(
    (state) => state.session.user.settings.preferDesktop,
  );

  useEffect(() => {
    if (isElectron) return;

    // we only want to show this toast when directly navigating to a post,
    // therefore, we don't depend on react router's location
    const isPost = matchEntityLink(window.location.href)?.type === 'post';

    if (shouldPreferDesktop && isPost) {
      dispatch(
        UIActions.pushToast(
          miscToasts.openInDesktopApp({
            to: window.location.href.replace(/https?:\/\//, 'slab://'),
          }),
        ),
      );
    }
  }, [shouldPreferDesktop, dispatch]);
};

export default usePreferDesktopNotice;
